module.exports = __webpack_public_path__ + "img/3.335157c9.png";